export const money = (n) => `$${Number(n || 0).toLocaleString("en-US")}`;

export const timeAgo = (iso) => {
    if (!iso) return "just now";
    const then = new Date(iso).getTime();
    if (Number.isNaN(then)) return "just now";
    const secs = Math.max(1, Math.floor((Date.now() - then) / 1000));
    if (secs < 60) return `${secs}s ago`;
    const mins = Math.floor(secs / 60);
    if (mins < 60) return `${mins}m ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h ago`;
    const days = Math.floor(hrs / 24);
    if (days < 30) return `${days}d ago`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months}mo ago`;
    return `${Math.floor(months / 12)}y ago`;
};

export const initials = (name) => {
    if (!name) return "?";
    const clean = name.replace(/^@/, "").replace(/^https?:\/\//, "");
    return clean.slice(0, 2).toUpperCase();
};
